import React from "react";
export default function Quotatoins() {
  return (
    <svg
      width="40"
      viewBox="0 0 55 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6808 1.93977V9.84074C23.6808 10.9123 22.6718 11.7805 21.4271 11.7805C16.9862 11.7805 14.5705 15.7017 14.2357 23.4408H21.4271C22.6718 23.4408 23.6808 24.3099 23.6808 25.381V42.0635C23.6808 43.1345 22.6718 44.0029 21.4271 44.0029H2.25324C1.00806 44.0029 0 43.1338 0 42.0635V25.381C0 21.671 0.433914 18.2665 1.2893 15.2609C2.16658 12.179 3.51323 9.48441 5.29064 7.25166C7.11957 4.95706 9.40731 3.15645 12.0908 1.90206C14.7925 0.64008 17.9342 0 21.4279 0C22.6718 0 23.6808 0.868225 23.6808 1.93977ZM52.7461 11.7806C53.9902 11.7806 55 10.9116 55 9.84087V1.93991C55 0.86836 53.9904 0.000135564 52.7461 0.000135564C49.2539 0.000135564 46.1117 0.640351 43.411 1.9022C40.727 3.15659 38.438 4.95719 36.6087 7.2518C34.832 9.48455 33.4853 12.1793 32.6079 15.2618C31.753 18.2684 31.319 21.6729 31.319 25.3812V42.0637C31.319 43.1347 32.3284 44.003 33.5728 44.003H52.746C53.9901 44.003 54.9989 43.134 54.9989 42.0637V25.381C54.9989 24.31 53.9902 23.4408 52.746 23.4408H45.6571C45.9869 15.7018 48.3673 11.7806 52.7461 11.7806Z"
        fill="#0D3E9D"
      />
    </svg>
  );
}
